import { jsx as t, jsxs as n } from "react/jsx-runtime";
import { f as i } from "../../vendor--aJiswR_.js";
import { Image as o } from "../Image/index.js";
import '../../assets/index49.css';const l = "_avatar_18jz2_1", v = "_text_18jz2_25", c = {
  avatar: l,
  text: v
}, j = ({ src: e, textValue: m = "", alt: r = "" }) => {
  const a = i(c.avatar);
  if (r.trim().length)
    return /* @__PURE__ */ t("div", { className: a, "data-component": "Avatar", children: /* @__PURE__ */ t(o, { objectFit: "cover", alt: r, src: e }) });
  const s = m.trim();
  return s.length ? /* @__PURE__ */ n("div", { className: a, "data-component": "Avatar", children: [
    /* @__PURE__ */ t(o, { objectFit: "cover", alt: "", src: e }),
    /* @__PURE__ */ t("span", { className: c.text, children: s })
  ] }) : /* @__PURE__ */ t("div", { className: a, "data-component": "Avatar" });
};
export {
  j as Avatar
};
//# sourceMappingURL=index.js.map
